import styled from "styled-components";
import { Paragraph, Heading } from "../../atoms/Typography/Typography.styles";

interface CardDocumentsProps {
  colorScheme: string
  withBackground: boolean
}

export const CardDocuments = styled.a<CardDocumentsProps>`
  width: 100%;
  padding-right: ${({ theme }) => theme.rem(24)};
  display: block;

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, withBackground, colorScheme }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'}!important;
  }

  i {
    font-size: ${({ theme }) => theme.rem(20)};
  }
`